import { intersect } from '@turf/turf';
/**
 * Check if two polygons intersect.
 *
 * @todo: Should we use `@turf/boolean-intersects` instead?
 */
const booleanPolygonsIntersects = (poly1, poly2) => Boolean(intersect(poly1, poly2));
export default booleanPolygonsIntersects;
